import React, { use, useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { UserContext } from '../../context/UserContext';
import { ClockLoader } from "react-spinners";
import LOGO from '../../images/CLS-Logo.png';

function LoginPage() {
    const [loading, setLoading] = useState(false);
    const [formFields, setFormFields] = useState({'email': '', 'password': ''});
    const { setTostMessage } = useContext(TostMessageContext);
    const [cookies, setCookie, removeCookie] = useCookies();
    const navigate = useNavigate();
    const {setUserProfile} = useContext(UserContext);

    const submit = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("email", formFields.email);
        formData.append("password", formFields.password);
        formData.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
        
        const date = new Date();
        let expiresDate = date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 24 hours

        try {
            const response = await axios.post(base_url + '/auth/login.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    // access: cookies.urbexEnterpriseUserToken,
                },
            });
            console.log(response);
            if (response.data.status) {
                setLoading(false);
                setTostMessage({
                    messageType: "success",
                    message: response.data.response,
                });
                setCookie("userProfile", response.data.user, {
                    path: "/",
                    maxAge: expiresDate,
                    secure: true,
                });
                setUserProfile(response.data.user);
                navigate("/home");
            } else {
                setLoading(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }
  return (
    <div className="relative h-screen h-full px-4">
        <div className="min-h-screen bg-gray-50 flex items-center justify-center relative">
            {/* Top Right Help/Support */}
            <div className="absolute top-4 right-6 flex space-x-4 text-sm text-gray-600">
                <a href="#" className="hover:underline">Help</a>
                <a href="#" className="hover:underline">Support</a>
            </div>

            {/* Login Card */}
            <div className='w-full flex flex-col items-center justify-center'>
                <div className='flex flex-col justify-start items-center w-full mt-[10px] mb-[30px]'>
                    <img src={LOGO} className="h-[80px] rounded-full mr-2" alt="logo" />
                    {/* <h1 className="font-bold text-[17px]">CHILDREN'S LANGUAGE SCHOOL</h1> */}
                </div>
                <div className="bg-white p-8 rounded-sm shadow-md w-full max-w-md">
                    <div className="mb-6 text-center">
                    <h1 className="text-2xl font-semibold text-gray-800">Children’s Language School</h1>
                    <p className="text-sm text-gray-500 mt-1">Enter your details to log in</p>
                    </div>

                    <div className='my-4'>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                        <input
                        type="email"
                        placeholder="Enter Email Address"
                        className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow"
                        onChange={(e) => setFormFields({...formFields, email: e.target.value})}
                        />
                    </div>

                    <div className="mb-2">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                        <input
                        type="password"
                        placeholder="Enter Password"
                        className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow"
                        onChange={(e) => setFormFields({...formFields, password: e.target.value})}
                        />
                    </div>

                    <div className="flex flex-col items-end gap-y-2 justify-end mb-6">
                        <a href="/reset-password" className="text-sm text-gray-500 hover:underline">
                        Forgot Password?
                        </a>
                    </div>

                    <button
                        onClick={() => submit()}
                        className="w-full bg-yellow hover:bg-yellow-500 text-black font-medium py-2 rounded-md transition"
                    >
                        {loading ? (
                            <ClockLoader
                                color={'#212121'}
                                loading={loading}
                                size={25}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                            ) : 'Log in'
                        }
                    </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default LoginPage;
